var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenScreenLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 461.7 566.6",
    style: {
      enableBackground: "new 0 0 461.7 566.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.55;fill:url(#SVGID_00000119797213214835395230000011030226560187006911_);}\r\n\t.st2{opacity:0.55;fill:url(#SVGID_00000140727599557200292820000006055380468173188766_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,564.3c-2.9,0-5.6-0.5-8.1-1.4c-2.5-1-4.7-2.3-6.5-4.1c-1.8-1.8-3.3-3.8-4.3-6.2c-1-2.4-1.5-5-1.5-7.9 c0-2.8,0.5-5.5,1.5-7.9c1-2.4,2.5-4.5,4.3-6.2c1.9-1.8,4-3.1,6.5-4.1c2.5-1,5.2-1.4,8.1-1.4c3.1,0,6,0.5,8.6,1.6 c2.6,1.1,4.8,2.7,6.5,4.8l-4.6,4.3c-1.4-1.5-2.9-2.6-4.6-3.4c-1.7-0.7-3.6-1.1-5.6-1.1c-2,0-3.8,0.3-5.5,1 c-1.7,0.7-3.1,1.6-4.3,2.8c-1.2,1.2-2.2,2.6-2.8,4.3c-0.7,1.6-1,3.4-1,5.4s0.3,3.8,1,5.4c0.7,1.6,1.6,3.1,2.8,4.3 c1.2,1.2,2.7,2.1,4.3,2.8c1.7,0.7,3.5,1,5.5,1c2,0,3.9-0.4,5.6-1.1c1.7-0.7,3.3-1.9,4.6-3.4l4.6,4.4c-1.8,2.1-4,3.7-6.5,4.7 C63.5,563.7,60.7,564.3,57.5,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2,564.3c-3,0-5.7-0.5-8.2-1.5c-2.5-1-4.7-2.4-6.5-4.1c-1.9-1.8-3.3-3.8-4.3-6.2c-1-2.4-1.5-5-1.5-7.8 c0-2.8,0.5-5.4,1.5-7.8c1-2.4,2.5-4.5,4.3-6.2c1.9-1.8,4-3.1,6.5-4.1c2.5-1,5.2-1.5,8.2-1.5c3,0,5.7,0.5,8.2,1.5 c2.5,1,4.7,2.4,6.5,4.1c1.9,1.8,3.3,3.8,4.3,6.2c1,2.4,1.5,5,1.5,7.8c0,2.8-0.5,5.5-1.5,7.9c-1,2.4-2.5,4.5-4.3,6.2 c-1.9,1.7-4,3.1-6.5,4.1C103.9,563.8,101.1,564.3,98.2,564.3z M98.1,558.1c1.9,0,3.7-0.3,5.3-1c1.6-0.7,3.1-1.6,4.3-2.8 c1.2-1.2,2.1-2.6,2.8-4.3c0.7-1.6,1-3.4,1-5.4s-0.3-3.8-1-5.4c-0.7-1.6-1.6-3-2.8-4.3c-1.2-1.2-2.6-2.2-4.3-2.8 c-1.6-0.7-3.4-1-5.3-1c-1.9,0-3.7,0.3-5.3,1c-1.6,0.7-3,1.6-4.3,2.8c-1.2,1.2-2.2,2.6-2.8,4.3c-0.7,1.6-1,3.4-1,5.4 c0,1.9,0.3,3.7,1,5.3c0.7,1.6,1.6,3.1,2.8,4.3c1.2,1.2,2.6,2.2,4.3,2.8C94.4,557.7,96.2,558.1,98.1,558.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,563.7v-38.2h17.9c4.6,0,8.1,0.9,10.5,2.7c2.4,1.8,3.6,4.2,3.6,7.2c0,2-0.5,3.8-1.4,5.2c-0.9,1.4-2.2,2.5-3.8,3.3 c-1.6,0.8-3.3,1.2-5.2,1.2l1-2c2.1,0,4.1,0.4,5.8,1.2c1.7,0.8,3.1,1.9,4.1,3.4c1,1.5,1.5,3.3,1.5,5.6c0,3.3-1.3,5.8-3.8,7.6 c-2.5,1.8-6.2,2.7-11.2,2.7H127.9z M135,558.2h11.5c2.7,0,4.7-0.4,6.1-1.3c1.4-0.9,2.1-2.3,2.1-4.2c0-1.9-0.7-3.3-2.1-4.2 c-1.4-0.9-3.5-1.3-6.1-1.3h-12v-5.5H145c2.5,0,4.4-0.4,5.7-1.3c1.3-0.9,2-2.2,2-3.9c0-1.8-0.7-3.1-2-4c-1.3-0.9-3.2-1.3-5.7-1.3 h-10V558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,563.7v-38.2h5.8l16.7,27.9h-3.1l16.4-27.9h5.8l0.1,38.2h-6.7l-0.1-27.7h1.4l-14,23.3h-3.2l-14.2-23.3h1.6v27.7H171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,563.7v-38.2h7.1v38.2H224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,563.7v-38.2h5.8l23.9,29.4h-2.9v-29.4h7v38.2h-5.8l-23.9-29.4h2.9v29.4H243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.6,563.7v-38.2h16.7c4.1,0,7.8,0.8,10.9,2.4c3.1,1.6,5.6,3.8,7.3,6.7c1.7,2.8,2.6,6.2,2.6,10c0,3.8-0.9,7.2-2.6,10 c-1.7,2.9-4.2,5.1-7.3,6.7c-3.1,1.6-6.8,2.4-10.9,2.4H289.6z M296.7,557.7h9.3c2.9,0,5.4-0.5,7.4-1.6c2.1-1.1,3.7-2.6,4.9-4.6 s1.7-4.3,1.7-6.9c0-2.7-0.6-5-1.7-6.9c-1.1-1.9-2.8-3.5-4.9-4.6c-2.1-1.1-4.6-1.6-7.4-1.6h-9.3V557.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,557.8h21.5v5.9h-28.6v-38.2h27.9v5.9h-20.8V557.8z M342.8,541.4h19v5.8h-19V541.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.4,563.7l16.1-22.1v5.3l-15.3-21.4h8l11.4,15.8l-3.3,0.1l11.3-15.9h7.7l-15.2,21v-5.1l16.2,22.3h-8.2l-12-16.8h3.2 l-11.8,16.8H369.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4376.5444,
    y1: 3438.6694,
    x2: -4249.8726,
    y2: 3911.4148,
    gradientTransform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -5418.1079 -222.444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E72144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#76549E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,279.1V178.5C3,82.2,81.8,3.4,178.1,3.4l104.7,0c96.3,0,175.1,78.8,175.1,175.1v100.7 c0,96.3-78.8,175.1-175.1,175.1l-104.7,0C81.8,454.2,3,375.4,3,279.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123437077038472221170000017393121969966391972_",
    gradientUnits: "userSpaceOnUse",
    x1: -2854.4702,
    y1: 2319.8867,
    x2: -2383.1091,
    y2: 2319.8867,
    gradientTransform: "matrix(-0.4174 0.4174 0.7071 0.7071 -2443.4863 -295.9606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000123437077038472221170000017393121969966391972_)"
    },
    d: "M277.4,349.7l111.1-111.1 c23.6-23.6,23.6-62.1,0-85.7l0,0c-23.6-23.6-62.1-23.6-85.7,0L191.7,264c-23.6,23.6-23.6,62.1,0,85.7l0,0 C215.3,373.2,253.8,373.2,277.4,349.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058560937230726885080000003195412676431998127_",
    gradientUnits: "userSpaceOnUse",
    x1: -338.3595,
    y1: 834.5375,
    x2: 133.0015,
    y2: 834.5375,
    gradientTransform: "matrix(0.4174 0.4174 -0.7071 0.7071 810.8228 -295.9606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000058560937230726885080000003195412676431998127_)"
    },
    d: "M190.5,349.7L79.5,238.6 c-23.6-23.6-23.6-62.1,0-85.7l0,0c23.6-23.6,62.1-23.6,85.7,0L276.2,264c23.6,23.6,23.6,62.1,0,85.7l0,0 C252.7,373.2,214.1,373.2,190.5,349.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenScreenLogo);
export default __webpack_public_path__ + "static/media/OpenScreenLogo.26f75631adf023a0ffe46d37d66edd51.svg";
export { ForwardRef as ReactComponent };